const cartAmountBadge = $('#cartAmountBadge');

const setCartBadge = (amount) => {
    if(typeof amount !== 'undefined' && amount > 0) {
        cartAmountBadge.text(amount);
        cartAmountBadge.removeClass('d-none');
    } else {
        cartAmountBadge.text('');
        cartAmountBadge.removeClass('d-none').addClass('d-none');
    }
};

const setCartPrice = (price) => {
    const cartPrice = $('.cartSum');
    if(typeof price !== 'undefined' && price !== 'Koszyk') {
        cartPrice.text(price);
    } else {
        cartPrice.text('Koszyk');
    }
}

const swapBlocks = (inputBlock, selectBlock, value, name) => {
    inputBlock.addClass('d-none');
    selectBlock.addClass('d-none');
    if(value < 9) {
        selectBlock.removeClass('d-none');
        selectBlock.find('select').val(value);
    } else {
        inputBlock.removeClass('d-none');
        inputBlock.find('input[name='+name+']').focus();
    }
};

const updateCartBlocks = (productLine, lastValue) => {
    const inputBlock = productLine.find('.prod-amount .input-block');
    const selectBlock = productLine.find('.prod-amount .select-block');
    // swapBlocks(inputBlock, selectBlock, lastValue, 'productAmount')
    if(cartAmountBadge.length === 1) {
        let total = 0;
        if(cartAmountBadge.hasClass('d-none')) {
            cartAmountBadge.removeClass('d-none');
        }
        $('.prod-amount .input-block input[name=productAmount]').each(function() {
            total += Number.parseInt($( this ).val(), 10);
        });
        if(!productLine.data().hasOwnProperty('plNoCart')) {
            setCartBadge(total);
        }
    }
};

const updateCartBlocksList = (productLine, lastValue) => {
    const inputBlock = productLine.find('.prod-amount .input-block');
    const selectBlock = productLine.find('.prod-amount .select-block');
    // swapBlocks(inputBlock, selectBlock, lastValue, 'listProductAmount')
};

const bind = function () {
    $('[data-app-cart=product]').each(function () {
        let lastValue = (lastValue || 0);
        const product = $(this);
        const inputBlock = product.find('.prod-amount .input-block');
        const inputAmount = inputBlock.find('input[name=productAmount]');
        const selectBlock = product.find('.prod-amount .select-block');
        const selectAmount = selectBlock.find('select');
        lastValue = inputAmount.val();
        updateCartBlocks(product, lastValue);
        selectAmount.off('change').on('change',function() {
            const currentValue = $(this).val();
            if(lastValue !== currentValue) {
                if(currentValue < 9) {
                    inputAmount.val(currentValue);
                    $(this).closest('form').trigger('submit');
                } else {
                    updateCartBlocks(product, (currentValue !== '' ? currentValue : lastValue));
                }
            }
        });

        inputAmount.on('keyup', function (e) {
            if (e.which === 27) {
                if(lastValue === '') {
                    lastValue = 1;
                }
                $(this).val(lastValue);
                updateCartBlocks(product, lastValue);
            }
        }).on('focusout', function () {
            const currentValue = $(this).val();
            if (lastValue !== currentValue) {
                if(currentValue !== '') {
                    $(this).closest('form').trigger('submit');
                } else {
                    $(this).val(lastValue);
                }
            }
            updateCartBlocks(product, lastValue);
        });
    });

    $('[data-app-cart=list]').each(function () {
        let lastValue = (lastValue || 0);
        const product = $(this);
        const inputBlock = product.find('.prod-amount .input-block');
        const inputAmount = inputBlock.find('input[name=listProductAmount]');
        const selectBlock = product.find('.prod-amount .select-block');
        const selectAmount = selectBlock.find('select');
        lastValue = inputAmount.val();
        updateCartBlocksList(product, lastValue);
        selectAmount.off('change').on('change',function() {
            const currentValue = $(this).val();
            if(lastValue !== currentValue) {
                if(currentValue < 9) {
                    inputAmount.val(currentValue);
                    $(this).closest('form').trigger('submit');
                } else {
                    updateCartBlocksList(product, (currentValue !== '' ? currentValue : lastValue));
                }
            }
        });

        inputAmount.on('keyup', function (e) {
            if (e.which === 27) {
                if(lastValue === '') {
                    lastValue = 1;
                }
                $(this).val(lastValue);
                updateCartBlocksList(product, lastValue);
            }
        }).on('focusout', function () {
            const currentValue = $(this).val();
            if (lastValue !== currentValue) {
                if(currentValue !== '') {
                    $(this).closest('form').trigger('submit');
                } else {
                    $(this).val(lastValue);
                }
            }
            updateCartBlocksList(product, lastValue);
        });
    });

    $('.add-to-cart-widget .amount-chooser').each(function () {
        const product = $(this);
        const inputBlock = product.find('.input-block');
        const inputAmount = inputBlock.find('input[name=productAmount]');
        const selectBlock = product.find('.select-block');
        const selectAmount = selectBlock.find('select');
        let prodLastValue = inputAmount.val();
        // swapBlocks(inputBlock, selectBlock, prodLastValue, 'productAmount');

        // selectAmount.change(function() {
        //     const currentValue = $(this).val();
        //     if(prodLastValue !== currentValue) {
        //         if(currentValue < 9) {
        //             inputAmount.val(currentValue);
        //             prodLastValue = currentValue;
        //         }
        //         swapBlocks(inputBlock, selectBlock, currentValue, 'productAmount');
        //     }
        // });

        inputAmount.on('keydown', function (e){
            if (e.which === 13){
                e.preventDefault();
                if($(this).val() <= 0 || $(this).val() === '') {
                    $(this).val(1);
                }
            }
        })
        inputAmount.on('keyup', function (e) {
            if (e.which === 27) {
                if(prodLastValue === '') {
                    prodLastValue = 1;
                }
                $(this).val(prodLastValue);
                // swapBlocks(inputBlock, selectBlock, prodLastValue, 'productAmount');
            }
        }).on('focusout', function () {
            const currentValue = $(this).val();
            if (prodLastValue !== currentValue) {
                if(currentValue !== '') {
                    prodLastValue = currentValue;
                } else {
                    $(this).val(prodLastValue);
                }
            }
            if($(this).val() <= 0){
                $(this).val(1);
            }
            // swapBlocks(inputBlock, selectBlock, prodLastValue, 'productAmount');
        });
    });

    const inputAmount = $('input[name=productAmount]');
    inputAmount.map(function () {
        if($(this).val() <= 1) {
            $(this).closest('.input-block').find('.minus-sign').css('color', '#ccc').css('cursor', 'not-allowed');
        }
    });

    $('.plus-sign').on('click', function (){
        $(this).closest('.input-block').find('input[name=productAmount]').val(parseInt($(this).closest('.input-block').find('input[name=productAmount]').val()) + 1);
        $(this).closest('form').trigger('submit');
    })

    $('.minus-sign').on('click', function (){
        if($(this).closest('.input-block').find('input[name=productAmount]').val() <= 1) {
            $(this).closest('.input-block').find('input[name=productAmount]').val(1);
            return;
        } else {
            $(this).closest('.input-block').find('input[name=productAmount]').val(parseInt($(this).closest('.input-block').find('input[name=productAmount]').val()) - 1);
        }
        $(this).closest('form').trigger('submit');
    })
    
    $('#priorityShipment').on('change', function(){
        if($(this).is('checked')) {
            $(this).attr('checked', 'false');
        } else {
            $(this).attr('checked', 'true');
        }
        $(this).closest('form').trigger('submit');
    })
};

const rangeSliderJs = function () {
    let base = document.querySelectorAll('input[type="range"]');
    if (base.length > 0) {
        https: rangesliderJs.create(base);

        let sliderEl = document.querySelector(".slider");
        let nrInput = document.querySelector(".nr-input");

        rangesliderJs.create(sliderEl, {
            onSlide: (val) => nrInput.setAttribute("value", val),
        });
        nrInput.addEventListener("input", (ev) =>
            sliderEl["rangeslider-js"].update({
                value: ev.target.value
            })
        );

        let slider2 = document.querySelector(".slider2");
        let nrInput2 = document.querySelector(".nr-input2");
        rangesliderJs.create(slider2, {
            onSlide: (val) => nrInput2.setAttribute("value", val),
        });
        nrInput2.addEventListener("input", (ev) =>
            slider2["rangeslider-js"].update({
                value: ev.target.value
            })
        );
    }
}

const installmentCalculation = function (){
    let $orderValueInput = $(".orderAll");
    let $payValueInput = $(".selfPay");
    let $installmentsValueInput = $(".installmentsAmount");
    let $sumAllInput = $(".sumAll");
    let orderValue = $orderValueInput.val();
    let payValue = $payValueInput.val();
    let installmentsValue = $installmentsValueInput.val();

    $sumAllInput.text(getInstallmentSummary());
    $(".sumAllStatic").text(getInstallmentSummary());

    $orderValueInput.on('change', function () {
        orderValue = $(this).val();
        $sumAllInput.text(getInstallmentSummary());
    });

    $payValueInput.on('change', function () {
        payValue = $(this).val();
        $sumAllInput.text(getInstallmentSummary());
    });

    $installmentsValueInput.on('change', function () {
        installmentsValue = $(this).val();
        $sumAllInput.text(getInstallmentSummary());
    });

    $('input[type="range"]').on('change', function () {
        orderValue = $orderValueInput.val();
        payValue = $payValueInput.val();
        installmentsValue = $installmentsValueInput.val();
        $sumAllInput.text(getInstallmentSummary());
    });

    function getInstallmentSummary() {
        let N = orderValue - payValue;
        let r = 0.163;
        let k = 12;

        return ((N * r) / (k * (1 - ((k / (k + r)) ** installmentsValue)))).toFixed(2);
    }

    $(".rating-rev > a").on('click', function () {
        $(".rating-rev a").removeClass("rated-star");
        $(this).addClass("rated-star");
    });

    function turnMenu() {
        $(".nav-main-top").closest('.nav-main').toggleClass("open-menu");
    }

    window.turnMenu = turnMenu;
}

export {
    bind,
    setCartBadge,
    setCartPrice,
    rangeSliderJs,
    installmentCalculation,
}
